<template>
    <div class="level-grid">
        <div
            class="level"
            v-for="level in levels"
            :key="level"
            :class="{ active: isLevelPass(level) }"
            @click="clickLevel(level)"
        >
            <img
                class="bg"
                :src="
                    require(`@/assets/Stage/Comics/home/levels/${level}.webp`)
                "
            />
            <img
                v-if="isLevelPass(level)"
                class="mark"
                src="@/assets/Stage/Comics/home/icon-mark.png"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        passLevels: Array,
    },
    computed: {
        levels() {
            return [1, 2, 3, 4, 'center', 5, 6, 7, 8];
        },
    },
    methods: {
        isLevelPass(level) {
            return this.passLevels?.includes(level);
        },
        clickLevel(level) {
            if (level !== 'center') this.$emit('click', level);
        },
    },
};
</script>

<style lang="scss" scoped>
.level-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    align-items: center;
    .level {
        display: grid;
        position: relative;
        &.active:before {
            content: "";
            width: 100%;
            height: 100%;
            position: absolute;
            border-radius: 15px;
            border: solid 5px #235194;
        }
        img.mark {
            position: absolute;
            top: -6px;
            left: -6px;
            width: 34px;
            height: 34px;
        }
        img.bg {
            width: 100%;
            object-fit: contain;
        }
    }
}
</style>
